import { render, staticRenderFns } from "./FPotensiMp4.vue?vue&type=template&id=0b52556c&scoped=true"
import script from "./FPotensiMp4.vue?vue&type=script&lang=js"
export * from "./FPotensiMp4.vue?vue&type=script&lang=js"
import style0 from "./FPotensiMp4.vue?vue&type=style&index=0&id=0b52556c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52556c",
  null
  
)

export default component.exports